import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles';
import Waves from 'node-waves';

class DepartmentCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditing: this.props.isCreatingNew ? true : false
		}
	}
	componentDidMount = () => {
		Waves.attach('.waves-btn', ['waves-button']);
		Waves.attach('.waves-icon', ['waves-circle']);
	};

	componentDidUpdate = () => {
		Waves.attach('.waves-btn', ['waves-button']);
		Waves.attach('.waves-icon', ['waves-circle']);
	};
	toggleEdit = () => {
		var isEditing = this.state.isEditing;
		if (this.props.isCreatingNew && isEditing) {
			this.props.onSave()
		}
		this.setState({
			isEditing: !isEditing
		})
	};
	onSave = () => {
		let val = this.refs.inputField.value
		this.props.onSave(val);
		this.setState({
			isEditing: false
		})
	};
	nyAck = () => {
		let val = this.refs.inputFieldNyAck.value
		this.props.addAck(val)
		this.refs.inputFieldNyAck.value = ""
	}
	render() {
		const { title, linkTo, canEdit, toggleFavorite, favorite, activities, removeAck } = this.props;

		return (
			<div style={styles.body} className="waves-btn">
				<div
					style={styles.clickContainer}
					onClick={() => { if (!this.state.isEditing) linkTo() }}
				/>
				<i
					className={favorite ? "fa fa-star" : "fa fa-star-o"}
					style={styles.star}
					onClick={toggleFavorite}
				/>
				{this.state.isEditing ?
					<div className="col-xs-12 text-left" style={styles.editTitle}>
						<div style={{ fontSize: 12 }}>
							Afdelingsnavn
							</div>
						<input
							ref="inputField"
							type="text"
							defaultValue={title ? title : ""}

							style={styles.input} />
						<i
							key="floppyIcon"
							className="waves-icon fa fa-floppy-o"
							style={styles.floppy}
							onClick={this.onSave} />
						<i
							key="pencilIcon"
							className="waves-icon fa fa-pencil"
							onClick={this.toggleEdit}
							style={[styles.pencil, styles.pencilActive]} />
						<div>
							<div style={{ fontSize: 12 }}>
								Aktiviter
								<div style={{ position: 'relative' }}>
									<i className="fa fa-info-circle" aria-hidden="true" style={{ position: 'absolute', bottom: 11, right: 11, cursor: 'pointer' }}
										onClick={(e) => {
											e.stopPropagation()
											this.setState({
												showUsageTooltip: !this.state.showUsageTooltip
											})
										}}></i>
									{this.state.showUsageTooltip ?
										<span style={{
											width: 320,
											height: 140,
											backgroundColor: '#555',
											color: '#fff',
											textAlign: 'center',
											borderRadius: 6,
											padding: '5px 15px',
											position: 'absolute',
											right: 26,
											bottom: 6,
											transition: 'opacity 1s',
											zIndex: 1000,
											whiteSpace: 'pre-line'
										}}>
											Aktiviteter bruges ved registrering af dagrapport.
											Her kan medarbejderne skrive hvor man timer der er blevet brugt på f.eks. Rengøring
                    </span>
										:
										null}
								</div>
							</div>
							<div>
								<div style={{ position: 'fixed', width: '94%' }}>
									<input
										ref="inputFieldNyAck"
										type="text"
										style={styles.inputAk}
										onClick={(e) => {
											e.stopPropagation()
										}}
									/>
									<button
										style={{ position: 'absolute', top: 6, right: 8, height: 25, lineHeight: 1 }}
										className="btn btn-default btn-sm"
										onClick={(e) => {
											e.stopPropagation()
											this.nyAck()
										}}
									>
										Tilføj
										</button>
								</div>
								<div style={{ height: 35, width: '100%' }}></div>
								<div style={styles.aksContainer}>
									{activities.map((a, index) =>
										<div key={index} style={styles.aks}>
											<i
												className="waves-icon fa fa-times"
												onClick={(e) => {
													e.stopPropagation()
													removeAck(index, a)
												}}
												style={styles.removeAk} />
											{a}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
					:
					<div className="col-xs-12" style={styles.titleBox}>
						{title}
						{canEdit ?
							<i
								className="waves-icon fa fa-pencil"
								onClick={this.toggleEdit}
								style={styles.pencil} />
							:
							null
						}

					</div>
				}
			</div>
		)
	}
}

var styles = {
	body: {
		position: 'relative',
		marginBottom: '20px',
		height: '310px',
		width: '100%',
		lineHeight: '310px',
		padding: '0px',
		borderRadius: '2px',
		backgroundColor: semanticColors.default,
		textAlign: 'center'
	},
	clickContainer: {
		width: '100%',
		height: '100%',
		cursor: 'pointer',
		zIndex: '1',
		position: 'relative'
	},
	titleBox: {
		height: '40px',
		lineHeight: '40px',
		position: 'absolute',
		textAlign: 'left',
		fontSize: '24px',
		top: '50%',
		marginTop: '-20px'
	},
	editTitle: {
		height: '40px',
		lineHeight: '40px',
		position: 'absolute',
		fontSize: '24px',
		top: '20%',
		marginTop: '-20px',
		zIndex: '2'
	},
	input: {
		fontSize: '16px',
		height: '35px',
		lineHeight: '35px',
		width: '220px',
		border: 'none',
		paddingLeft: '5px',
		borderRadius: '2px',
		boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
		display: 'inherit'
	},
	aks: {
		height: 35,
		fontSize: '12px',
		display: 'inline-block',
		paddingRight: 5,
		paddingLeft: 5,
	},
	aksContainer: {
		height: 115,
		width: '108%',
		flexWrap: 'wrap',
		display: 'flex',
		overflowY: 'scroll',
		paddingRight: 10,
	},
	removeAk: {
		verticalAlign: 'middle',
		lineHeight: 2,
	},
	inputAk: {
		fontSize: '16px',
		height: '35px',
		lineHeight: '35px',
		width: '100%',
		border: 'none',
		paddingLeft: '5px',
		borderRadius: '2px',
		boxShadow: '0 1px 2px rgba(0,0,0,0.2), 0 -1px 0 rgba(0,0,0,0.05)',
		display: 'inherit'
	},
	floppy: {
		position: 'absolute',
		top: '0px',
		right: '45px',
		zIndex: '2',
		fontSize: '20px',
		color: semanticColors.text,
		cursor: 'pointer',
		width: '35px',
		height: '35px',
		lineHeight: '35px',
		textAlign: 'center',
		padding: '0px'
	},
	pencil: {
		position: 'absolute',
		top: '0px',
		right: '0px',
		zIndex: '2',
		fontSize: '20px',
		color: semanticColors.text,
		cursor: 'pointer',
		width: '35px',
		height: '35px',
		lineHeight: '35px',
		textAlign: 'center',
		padding: '0px'
	},
	pencilActive: {
		color: semanticColors.info
	},
	star: {
		position: 'absolute',
		top: '0px',
		right: '0px',
		zIndex: '2',
		fontSize: '20px',
		color: semanticColors.text,
		cursor: 'pointer',
		width: '40px',
		height: '40px',
		lineHeight: '40px',
		textAlign: 'center'
	}
}
DepartmentCard.propTypes = {
	title: PropTypes.string.isRequired,
	linkTo: PropTypes.func.isRequired,
	canEdit: PropTypes.bool.isRequired,
	onSave: PropTypes.func.isRequired,
	isCreatingNew: PropTypes.bool,
	favorite: PropTypes.bool.isRequired,
	toggleFavorite: PropTypes.func.isRequired
};
export default Radium(DepartmentCard);



// WEBPACK FOOTER //
// ./src/App/Department/departmentCard.jsx